import React from 'react';
import { connect } from 'react-redux';
import { RootState } from 'reducers';
import { Document2Icon } from 'assets/icons';
import { StorageService } from 'services';
import { Constants, Globals } from 'utils';
import moment from 'moment';
import { WhiteImage } from 'assets/img';

interface Props extends RootState {
  loadComments: (withoutLoading?: boolean) => Promise<any>;
}

class ViewComments extends React.Component<Props> {
  messagesEnd: any = null;

  state = {
    messages: [],
    chat: null,
    visible: false,
  };

  componentDidMount() {
    this.load();
  }

  load = async (withoutLoading: boolean = false) => {
    const res: any = await this.props.loadComments(withoutLoading);
    this.setState(
      {
        messages: res.messages || [],
        chat: res?.revision,
      },
      () => {
        this.scrollToBottom();
      },
    );
  };

  scrollToBottom = () => {
    this.messagesEnd.scrollTo({
      behavior: 'smooth',
      top: this.messagesEnd.scrollHeight,
    });
  };

  openFile = async (key: string) => {
    const opened = await StorageService.openFile(key);
    if (!opened) Globals.showError('No se pudo obtener el archivo');
  };

  render() {
    const { messages, chat } = this.state;
    const currentChat = chat as any;

    return (
      <div id='modal-preparation-comments'>
        <div className='row'>
          <div className='col-md-12'>
            <div className='container-header'>
              <div className='container-images-modal'>
                <img
                  src={
                    currentChat?.user?.photo
                      ? Constants.BASE_STORAGE + currentChat.user.photo
                      : WhiteImage
                  }
                />
                {currentChat?.lawyer != null && (
                  <img
                    src={
                      currentChat?.lawyer?.photo
                        ? Constants.BASE_STORAGE + currentChat.lawyer.photo
                        : WhiteImage
                    }
                    className='img-lawyer'
                  />
                )}
              </div>
              <p className='names'>
                {currentChat?.user?.full_name} y {currentChat?.lawyer?.full_name}
              </p>
            </div>

            <div
              className='container-messages'
              ref={(el) => {
                this.messagesEnd = el;
              }}
            >
              {!!messages.length ? (
                messages.map((item: any) => {
                  const is_right = item.user_id == (chat as any)?.lawyer?.id;
                  if (item.file) {
                    return (
                      <button
                        key={item.id}
                        type='button'
                        className={`link-file ${is_right ? 'self' : ''}`}
                        onClick={() => this.openFile(item.file)}
                      >
                        <p className='chat-name'>{`${item?.user?.name} ${item?.user?.lastname}`}</p>
                        <img src={Document2Icon} />
                        <p>
                          Archivo Adjunto <span>({item.file.split('.').pop()})</span>
                        </p>
                      </button>
                    );
                  } else {
                    return (
                      <div key={item.id} className={`item-message ${is_right ? 'self' : ''}`}>
                        <p className='chat-name'>{`${item?.user?.name} ${item?.user?.lastname}`}</p>
                        <p className='message'>{item.message}</p>
                        <p className='date'>{moment(item.created_at).format('DD/MM/YYYY HH:mm')}</p>
                      </div>
                    );
                  }
                })
              ) : (
                <p className='no-chat'>No se han hecho comentarios para la revisión documental</p>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default connect((state: RootState) => {
  return { user: state.user };
})(ViewComments);
